import { InputLabel, TextField } from '@mui/material'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

export interface IInputLabelCustom {
  hasError?: boolean
}

export const InputLabelCustom = styled(InputLabel)<IInputLabelCustom>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
  &:after {
    content: ' ';
    white-space: pre;
  }
`
export interface ITextField {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
  allowTyping?: boolean
}

export const TextFieldStyled = styled(TextField)<ITextField>`
  width: ${({ width }) => width || '100%'};
  // Impede ou não de digitar no campo
  ${({ allowTyping }) => !allowTyping && `pointer-events: none;`}

  && {
    margin-top: ${({ marginTop }) => marginTop};
    margin-bottom: ${({ marginBottom }) => marginBottom};
    margin-left: ${({ marginLeft }) => marginLeft};
    margin-right: ${({ marginRight }) => marginRight};
    width: ${({ width }) => width || '100%'};
    border: none;
  }

  *:before {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  }
`

export const TextFieldContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`

export const CalendarButton = styled.div`
  position: absolute;
  right: 0;
  &,
  div,
  div div,
  button {
    width: 100%;
    height: 100%;
    margin-left: 0;
  }
  button {
    display: flex;
    justify-content: flex-end;
    border-radius: 0px;
    padding-right: 0;
  }
`

export const ClearDateButton = styled.div`
  position: absolute;
  right: 30px;
  cursor: default;
  display: flex;
`
